/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRequestInformationS = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 18H8.499L5.5 22H2V2h20zm-11-5v2h2v-2zm1-8.1c-1.012 0-1.781.366-2.3.983-.518.614-.779 1.467-.8 2.43l-.003.103H10.6v-.099c.007-.454.135-.894.372-1.216.235-.32.578-.528 1.029-.528.338 0 .691.11.958.313.265.2.442.49.442.86 0 .323-.151.598-.377.848a3.555 3.555 0 0 1-.377.353l-.408.32c-.268.206-.523.405-.719.703-.172.263-.294.597-.35 1.071l-.019.212v.847h1.638l.008-.092.053-.64c.115-.742.587-1.226 1.16-1.645v-.001c.289-.218.567-.427.768-.75.203-.326.323-.757.323-1.412 0-.524-.115-1.19-.567-1.728-.455-.54-1.237-.932-2.533-.932z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRequestInformationS as RequestInformationS };
